import actionBuilder from 'store/v2/actions';
import { show as showAction, update as updateAction } from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

const defaultActions = {
  ...actionBuilder({ apiPath, bulkActionType, actionType }),
  show: (queryParams = {}) => {
    return showAction(actionType, apiPath, queryParams);
  },
  update: (payload, silent = false) => {
    return updateAction(actionType, apiPath, { ...payload, silent });
  },
};

export default defaultActions;
